var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.473,
    height: 23,
    viewBox: "0 0 22.473 23",
    className: "sc-fzpans cKJzHK",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.963,3a8.963,8.963,0,1,0,4.794,16.525L24.232,26l2.241-2.241L20.08,17.383A8.943,8.943,0,0,0,12.963,3Zm0,2.109a6.854,6.854,0,1,1-6.854,6.854A6.841,6.841,0,0,1,12.963,5.109Z",
    transform: "translate(-4 -3)",
    fill: "#4A6FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.386bd4f1075c9e7d238dff2a3b35f3b2.svg";
export { ForwardRef as ReactComponent };